import { Component } from "react";
import { Link } from "react-router-dom";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import dayjs from "dayjs";
import { TableCell, TableRow, Stack, Typography, Avatar } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import CircularProgress from "@mui/material/CircularProgress";
import { connect } from 'react-redux';

// Icons
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import InventoryIcon from "@mui/icons-material/Inventory";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

function formatPhoneNumber(phoneNumber) {
  if (phoneNumber.startsWith("+")) {
    const prefix = phoneNumber.slice(0, 4);
    const rest = phoneNumber.slice(4);
    return prefix + " " + rest.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3");
  } else {
    return phoneNumber.replace(/(\d{2})(\d{3})(\d{2})(\d{2})/, "$1 $2 $3 $4");
  }
}

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

class UserItem extends Component {
  constructor(props) {
    super(props);
    this.isUserAdmin = this.props.isUserAdmin;
    this.renderType = this.renderType.bind(this);
  }

  renderType(user) {
    let role = user?.roles.length > 0 ? user?.roles[0].replace("ROLE_", "") : null;
    let roleName = "--";
    let icon = null;

    if (role) {
      var names = {
        COMMISSIONNAIRE: "Expéditeur",
        TRANSPORTEUR: "Transporteur",
        CHAUFFEUR: "Chauffeur",
      };

      var icons = {
        COMMISSIONNAIRE: <InventoryIcon sx={{ color: "primary", width: 16 }} />,
        TRANSPORTEUR: <LocalShippingIcon sx={{ color: "primary", width: 16 }} />,
        CHAUFFEUR: <LocalShippingIcon sx={{ color: "primary", width: 16 }} />,
      };
      var backgroundColors = {
        COMMISSIONNAIRE: "#FDF2E6",
        TRANSPORTEUR: "#E8EDED",
        CHAUFFEUR: "transparent",
      };
      var textColors = {
        COMMISSIONNAIRE: "#E77A05",
        TRANSPORTEUR: "primary.main",
        CHAUFFEUR: "primary.main",
      };
      var borderColors = {
        COMMISSIONNAIRE: "transparent",
        TRANSPORTEUR: "transparent",
        CHAUFFEUR: "primary.main",
      };
      roleName = names[role];
      icon = icons[role];
      backgroundColors = backgroundColors[role];
      textColors = textColors[role];
      borderColors = borderColors[role];
    }
    return (
      <Stack
        direction="row"
        alignItems="center"
        gap={1}
        sx={{
          fontSize: 14,
          px: 1.5,
          py: 0.5,
          backgroundColor: backgroundColors,
          color: textColors,
          borderRadius: 400,
          border: `1px solid transparent`,
          borderColor: borderColors,
          width: "fit-content",
          fontWeight: 700,
        }}
      >
        {icon} {roleName}
      </Stack>
    );
  }

  render() {
    const { user, deleteUser, updateUser, in_progress, selected, toggleSelectUser, toggleStatus } = this.props;
    return (
      <>
        <TableRow hover selected={false}>
          <TableCell>{user?.id}</TableCell>

          <TableCell>
            <Typography variant="body2" color="textSecondary">
              {user?.created_at ? dayjs(user?.created_at).format("DD/MM/YYYY HH:mm") : "-"}
            </Typography>
          </TableCell>

          <TableCell>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Avatar alt={user?.society} src={`${this.props.server.BASE_URL}${user?.logo}`} sx={{ width: 32, height: 32 }} />
              <Stack>
                <Typography gutterBottom sx={{ fontSize: 14, mb: 0, color: "text.primary" }}>
                  {user?.firstname?.toUpperCase()} {user?.lastname}
                </Typography>
                <Typography
                  sx={{
                    fontSize: 14,
                    color: "text.secondary",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 0.5,
                  }}
                >
                  {user?.email}
                  {user?.isVerified ? (
                    <CheckIcon sx={{ color: "success.main", width: 14 }} />
                  ) : (
                    <CloseIcon sx={{ color: "error.main", width: 14 }} />
                  )}
                </Typography>
              </Stack>
            </Stack>
          </TableCell>

          <TableCell>{user?.telephone ? formatPhoneNumber(user?.telephone) : "--"}</TableCell>

          <TableCell>{this.renderType(user)}</TableCell>

          <TableCell>{user?.society}</TableCell>

          {this.isUserAdmin && (
            <>
              <TableCell sx={{ display: "flex" }}>
                {in_progress && <CircularProgress />}
                {!in_progress && (
                  <>
                    <BootstrapTooltip title="Consulter" placement="top" color={"primary"}>
                      <IconButton
                        size="large"
                        color={"primary"}
                        aria-label="Dossier"
                        component={Link}
                        to={"/users/" + user?.id}
                      >
                        <FolderCopyIcon />
                      </IconButton>
                    </BootstrapTooltip>
                  </>
                )}
              </TableCell>
            </>
          )}
        </TableRow>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  server: state.server,
});

// Connecte le composant au store Redux
export default connect(mapStateToProps)(UserItem);
